class Api {
  static actionTypeEnum = {
    read: "read",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth) {
    this.levelId = { realm: auth.realm?.id, org: auth.orgs?.id, site: auth.sites?.id };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  }

  _getBaseUrl() {
    return this.isStandAlone ? `/orgs/:orgId/sites/:siteId` : `/ents/:entId/orgs/:orgId/sites/:siteId`;
  }

  getConnectSuccessRateParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectSuccessRate`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getConnectTimeParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectTime`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getGuestAccessHappinessParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/guestAccessHappiness`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  // Authentication Time Drawer APIs
  getConnectTimeDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectTime/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getConnectTimeSsidsParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectTime/ssids`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  // Connection Success Rate Drawer APIs
  getConnectSuccessRateDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectSuccessRate/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getConnectSuccessRateSsidsParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/connectSuccessRate/ssids`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  // Captive Portal Access Satisfaction Drawer APIs
  getGuestAccessHappinessDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/guestAccessHappiness/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getGuestAccessHappinessSsidsParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/serviceExperience/guestAccessHappiness/ssids`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }
}

export default Api;
